import React from 'react';

const CatalogAnchor = ({ catalogLink, onClick, children }) => {
	if (catalogLink) {
		return (
			<a href={catalogLink.href} target={catalogLink.target} onClick={onClick}>{children}</a>
		);
	} else {
		return <span>{children}</span>;
	}
};

export default CatalogAnchor;



// WEBPACK FOOTER //
// ./src/react/views/catalogAnchor/CatalogAnchor.jsx